import { gql } from '@apollo/client';

export const MANAGED_INTERVENTION_PEOPLE = gql`
  query ManagedInterventionPeopleProfiles($input: FilterInterventionPeopleProfiles!) {
    people: filteredInterventionPeopleProfiles(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          persalNumber
          nationalID
          cohorts {
            id
            name
            intervention {
              id
            }
          }
          institutions {
            id
            name
            emisNumber
          }
          interventionManagers {
            id
            endDate
            isArchived
            reasonForArchiving
            role
            startDate
            peopleProfile {
              id
            }
            intervention {
              id
            }
          }
          primaryInstitution {
            id
            name
            emisNumber
          }
          grades {
            id
            value
            name
          }
          type {
            id
            name
          }
        }
      }
    }
  }
`;
